import { SubmitButtonBase } from "@compass/core";
import { ButtonProps as MuiButtonProps, SxProps } from "@mui/material";
import { ReactNode } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { RootState } from "redux/store";

export const SubmitButton = (
  props: MuiButtonProps & {
    label?: ReactNode;
    disabled?: boolean;
    theme?: "Dark" | "Standard";
  }
) => {
  const appLoading = useSelector((state: RootState) => state.app.loading);
  const disabledOnLoading = appLoading > 0; // submit button needs to be disabled when loading

  const location = useLocation();
  const hasDialog = location.pathname.includes('dialog');

  const darkModeStyle: SxProps = ({
      color: "#ffffff",
      backgroundColor: props.disabled ? "#08519c" : "#08519c", 
      border: props.disabled ? "1px solid #08519c" : "1px solid #eff3ff",
      fontWeight: 600,
      opacity: props.disabled ? 0.85 : 1, 
      cursor: props.disabled ? "default" : "pointer",
      "&:hover": {
        backgroundColor: "rgba(255,255,255,0.1)",
        borderColor: "#eff3ff",
      }
  });

  const { label, disabled, theme, ...rest } = props;
  return <SubmitButtonBase sx={theme == "Dark" || hasDialog ? {...darkModeStyle, ...props.sx} : {...props.sx}} label={label} disabled={disabledOnLoading || disabled} {...rest} />;
};
